var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
}

site.extras = {
	init: function() {
		if($('#extras .torg.category').length) {
			site.extras.torg();
		}
		$('#extras .minni.category .item').click(function() {
			location.href= $(this).find('.title').attr('href');
		});
	},
	torg: function() {
		// Make card clickable
		$('#extras .item').click(function() {
			location.href= $(this).find('.title').attr('href');
		});

		// Toogle button
		site.extras.filter.initToggleButton();

		// Dropdown height
		$filter = $('#extras #itemFilter');
		$filter.css('max-height', $filter[0].scrollHeight);

		$('#extras .filterLabels').on('click','span',function(e) {
			e.preventDefault();
			$('#itemFilter').find("a[data-filter-value='."+$(this).attr('class')+"']").trigger('click');
		});
	},
	torgLabels: function(element) {
		$labels = $('#extras .filterLabels');
		if(element.hasClass('selected')) {
			$labels.append('<span class="' + element.data('filter-value').substring(1) + '">' + element.text() + '</span>');
		}
		else {
			$labels.find(element.data('filter-value')).remove();
		}
	},
	initSearch: function() {
		$searchElement = $('.filterControls .searchFilter input[type="text"]');
		$searchForm = $('.filterControls > form');
		itemContainer = document.querySelector('.items');

		if ($searchElement.length === 0 || !itemContainer) return;

		showAllItems = () => {
			for (let item of itemContainer.children) {
				item.classList.remove('hidden')
			}
		}

		const removeSpanChildren = (element) => {
			for (let child of element.children) {
				if (child.tagName === 'SPAN') {
					element.removeChild(child);
				} else {
					element.replaceChild(removeSpanChildren(child), child)
				}
			}
			return element;
		}

		filterItems = (searchValue) => {
			for (let item of itemContainer.children) {
				let tmpItem = item.cloneNode(true);
				tmpItem = removeSpanChildren(tmpItem);
				if (tmpItem.textContent.toLowerCase().search(searchValue.toLowerCase()) === -1) {
					item.classList.add('hidden');
				} else {
					item.classList.remove('hidden')
				}
			}
		}

		$searchForm.on('submit', (e) => {
			e.preventDefault();
		});

		$searchElement.on('input', (e) => {
			let searchValue = $searchElement.val().trim();
			var site = site || {};
			if (!searchValue) {
				showAllItems();
				return;
			}

			filterItems(searchValue);
		})
	}
}

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.sidebar = {
	init: function() {
		var $body = $('body');
		if ($body.width()+15 >= 992) {
			var h = $('#header').outerHeight();
			var p = $('#page').outerHeight();
			$('#sidebar').css('min-height',p-h);
		}
	}
};

site.frontpage = {
	init: function() {
		site.owl.init('#owl-hero', {
			nav:true,
			navText:['<i class="fa fa-angle-left" />','<i class="fa fa-angle-right" />'],
			items:1,
			dots:false
		});
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.megamenu.init();

	if ($('body').is('.frontpage')) {
		site.frontpage.init();
	}
	else {
		site.sidebar.init();
		if ($('body').is('.extras')) {
			site.extras.init();
			site.extras.initSearch();
		}
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$('body').is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Touch login
	$('.login').dblclick(function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
